<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <div class="mb-1 d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">

      <div class="d-flex flex-column justify-content-center">
        <div class="mb-1">
          <span style="font-size: 16px; font-weight: 600;">سفارش #{{ Form.Id }} </span>
          <b-badge
            v-if="Form.IsPaid"
            variant="light-success"
          >
            پرداخت شده
          </b-badge>
          <b-badge
            v-else
            variant="light-warning"
          >
            پرداخت نشده
          </b-badge>
          <b-badge
            v-if="Form.Status !== null"
            class="ml-1"
            :variant="'light-'+enums('OrderStatus', 'value', Form.Status, 'badge')"
          >
            {{ enums('OrderStatus', 'value', Form.Status, 'text') }}
          </b-badge>
        </div>
        <p class="mb-0">
          {{ Form.CreatedAt | date('jDD jMMMM jYYYY، ساعت HH:mm') }}
        </p>
      </div>
      <b-button
        v-if="Form.Status == 0"
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        variant="primary"
        @click="changeStatus(1)"
      >تایید سفارش
      </b-button>
    </div>
    <b-row>
      <b-col md="8">
        <b-card title="جزئیات سفارش">
          <div class="mb-3">
            <h5>عنوان خدمت</h5>
            <p
              class="mb-1"
            >
              {{ Form.Duty.Title }}
            </p>
            <h5>مبلغ پرداختی</h5>
            <p
              class="mb-1"
            >
              {{ Form.Price | price }} تومان
            </p>
          </div>

          <!--          <div class="mt-2">-->
          <!--            <div class="divider divider-solid divider-left">-->
          <!--              <div-->
          <!--                  class="divider-text"-->
          <!--                  style="font-weight: 600;"-->
          <!--              >-->
          <!--                اطلاعات درخواست-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->

          <div
            v-for="item in Form.DutyOrderQuestion"
            style="margin-top: 1rem;"
          >
            <h5>
              {{ item.DutyQuestion.Title }}
            </h5>
            <p
              v-if="item.Description"
              class="mb-1"
            >
              {{ item.Description }}
            </p>
            <p
              v-for="op in item.DutyOrderQuestionOption"
              v-else-if="item.DutyOrderQuestionOption.length"
              class="mb-1"
            >
              {{ op.DutyQuestionOption.Title }}
            </p>
            <p
              v-for="at in item.DutyOrderQuestionAttachment"
              v-else-if="item.DutyOrderQuestionAttachment.length"
              class="mb-1"
            >
              <a
                target="_blank"
                :href="at.Url"
              >{{ at.Url }}</a>
            </p>
            <p
              v-else
              class="mb-1"
            >
              -
            </p>
          </div>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card
          v-if="Form.User"
          title="اطلاعات مشتری"
        >
          <div>
            <b-link>
              <b-media
                vertical-align="center"
                style="align-items: center;"
              >
                <template #aside>
                  <b-avatar
                    :src="Form.User.Image"
                  />
                </template>
                <span
                  class="font-weight-bold d-block text-nowrap"
                  style="color: #6e6b7b;"
                >
                  {{ Form.User.Name }} {{ Form.User.Family }}
                </span>
                <small class="text-muted">{{ Form.User.Mobile }}</small>
              </b-media>
            </b-link>
          </div>
          <div class="mt-1 mb-1">
            <b-avatar
              variant="light-success"
              class="mr-1"
            >
              <feather-icon
                class="cursor-pointer"
                icon="ShoppingCartIcon"
              />
            </b-avatar>
            <span>{{ Form.User.Order.length }} سفارش</span>
          </div>
        </b-card>
        <b-card title="اطلاعات کلی">
          <div>
            <h5>نام و نام خانوادگی</h5>
            <p
              class="mb-1"
            >
              {{ Form.Name }}
            </p>
          </div>
          <div>
            <h5>موبایل</h5>
            <p
              class="mb-1"
            >
              {{ Form.Mobile }}
            </p>
          </div>
          <div>
            <h5>توضیحات</h5>
            <p
              class="mb-1"
            >
              {{ Form.Description ? Form.Description: "-" }}
            </p>
          </div>
          <div>
            <h5>کد پیگیری</h5>
            <p
              class="mb-1"
            >
              {{ Form.TrackingCode }}
            </p>
          </div>
        </b-card>
      </b-col>

    </b-row>

    <b-modal
      v-if="showModal"
      v-model="showModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="ویرایش"
      :no-close-on-backdrop="true"
      size="sm"
      @ok="savePostalTrackingCode"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            label="کدرهگیری"
            label-for="Title"
          >
            <b-form-input
              id="Title"
              v-model="postalTrackingCode"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>
      </b-row>

    </b-modal>
  </b-overlay>
</template>

<script>

import ProductCategory from '@/tools/productcategory.vue'

export default {
  name: 'OrderDetails',
  components: { ProductCategory },
  data() {
    return {
      Form: {
        Id: null,
      },
      loading: false,
      showModal: false,
      PostalTrackingCode: null,
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Product',
          label: 'عنوان',
        },
        {
          key: 'Price',
          label: 'مبلغ',
        },
        {
          key: 'Discount',
          label: 'تخفیف',
        },
        {
          key: 'PackagingPrice',
          label: 'هزینه بسته بندی',
        },
        {
          key: 'Quantity',
          label: 'تعداد',
        },
      ],
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.productcategory.add
      if (this.$route.params.id) {
        url = this.$api.productcategory.update
      }

      console.log(this.$refs.productcategoryform)

      const formData = new FormData(this.$refs.productcategoryform)
      formData.append('Id', this.Form.Id)
      formData.append('Description', this.Form.Description)
      formData.append('SliderSortBy', this.Form.SliderSortBy)

      if (this.Form.ProductCategoryId) {
        formData.append('ProductCategoryId', this.Form.ProductCategoryId)
      }

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    imageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.Image = fileReader.result
      }
    },
    sliderImageRenderer(event) {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(event.target.files[0])

      fileReader.onload = () => {
        this.Form.SliderImage = fileReader.result
      }
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.dutyorder.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
    changeStatus(status) {
      this.loading = true
      this.$http.post(
        this.$api.dutyorder.changestatus, {
          Id: this.Form.Id,
          Status: status,
        },
      )
        .then(res => {
          this.get()
        })
    },
    savePostalTrackingCode() {
      this.loading = true
      this.$http.post(
        this.$api.order.updatepostaltrackingcode, {
          Id: this.Form.Id,
          PostalTrackingCode: this.postalTrackingCode,
        },
      )
        .then(res => {
          this.get()
        })
    },
    showPostalTrackingCodeModal() {
      this.postalTrackingCode = this.Form.PostalTrackingCode
      this.showModal = true
    },
  },
}
</script>

<style scoped>

.w-px-120 {
  width: 120px !important;
}
h5{
  font-weight: 600;
  font-size: 14px !important;
}
</style>
